<div class="golden-carousel">
  <h3>{{ title | i18next }}</h3>
  <sharry-scrollable-elements [customTemplate]="templateGoldenBox">
    <ng-template #templateGoldenBox>
      @for (box of goldenBoxes; track box.icon) {
        <span class="golden-carousel__golden-box">
          <sharry-icon
            class="svg-icon"
            [type]="$any(box.type)"
            [name]="box.icon"></sharry-icon>
          <h3>
            {{ box.title | i18next }}
          </h3>
          <p>{{ box.subtitle | i18next }}</p>
          @if (!!box.button) {
            <button
              mat-flat-button
              color="primary"
              class="sharry-medium rounded mat-golden"
              (click)="openSupportDialog()">
              {{ box.button | i18next }}
            </button>
          }
        </span>
      }
    </ng-template>
  </sharry-scrollable-elements>
</div>
